// extracted by mini-css-extract-plugin
export default {"container":"textarea_container__xjCJ6","textarea":"textarea_textarea__G+k7d","errorContainer":"textarea_errorContainer__Qf238"};